import { NativeDateAdapter } from "@angular/material/core";
import { DayDate } from "../core/date-format/dayDate";
import { Injectable } from "@angular/core";

@Injectable()
export class CustomDatePickerAdapter extends NativeDateAdapter {
  override parse(value: string | number): Date | null {
    const date = DayDate.new(value);
    if (date == null || !date.isValid())
      return null;
    return date.toDate();
  }

  override format(date: Date, display: any): string {
    const dt = DayDate.new(date);
    return dt.format("L");
  }

  override getFirstDayOfWeek(): number {
    return 1;
  }
}

export const CUSTOM_DATE_FORMATS = {
  parse: {
    dateInput: { month: "short", year: "numeric", day: "numeric" }
  },
  display: {
    dateInput: "customInput",
    monthYearLabel: { year: "numeric", month: "short" },
    dateA11yLabel: { year: "numeric", month: "long", day: "numeric" },
    monthYearA11yLabel: { year: "numeric", month: "long" }
  }
};


export const CUSTOM_DATE_FORMATS_DAYJS = {
  parse: {
    dateInput: "L",
  },
  display: {
    dateInput: "L",
    monthYearLabel: "MMM YYYY",
    dateA11yLabel: "L",
    monthYearA11yLabel: "MMMM YYYY",
  },
};
